import React from "react";
import DateTimePicker from "react-datepicker";
import styled, { withTheme } from "styled-components";

const StyledWrapper = styled.div`
  .react-datepicker-wrapper {
    .react-datepicker__input-container {
      input {
        border: 0;
        border-radius: 0;
        background-color: ${(props) => props?.theme?.white};
        color: ${(props) => props?.theme?.gray};
        padding: 0.7rem 0 0 0.375rem;
        margin-right: 20px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        border-bottom: 2px solid ${(props) => props?.theme?.dustyGray};
        height: calc(1.5em + 0.75rem + 2px);
        width: 100%;
        font-size: 1rem;
        font-weight: 600;
        line-height: 1.5;

        &:hover {
          cursor: pointer;
          border-bottom: 2px solid ${(props) => props.theme?.darkPurple} !important;
        }

        &:focus {
          outline: none;
          color: ${(props) => props.theme?.slateGray};
        }
      }
    }
  }
`;

const NullableDateTime = (props) => {
  const { dateTime, setDateTime, onKeyDown } = props;

  return (
    <StyledWrapper>
      <DateTimePicker
        onKeyDown={onKeyDown}
        customInput={
          <input
            data-testid={props["data-testid"] ?? "nullable-date-time-picker"}
            type="text"
            className="react-datepicker-ignore-onclickoutside"
          />
        }
        selected={dateTime}
        onChange={(date) => setDateTime(date)}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        timeCaption="Time"
        dateFormat="dd/MMM/yyyy HH:mm"
      />
    </StyledWrapper>
  );
};

export default withTheme(NullableDateTime);
